import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {path: '/privacy', component: () => import('@/views/privacy/index'), hidden: true},
  {path: '/destiny/calcresult', component: () => import('@/views/login/index'), meta: {title: '测算结果'}, hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  },
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/goods',
    name: 'pms',
    meta: {title: '商品', icon: 'product'},
    children: [
      /*{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),
      meta: {title: '商品列表', icon: 'product-list'}
    },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/pms/product/add'),
        meta: {title: '添加商品', icon: 'product-add'}
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/product/update'),
        meta: {title: '修改商品', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'productRecycle',
        name: 'productRecycle',
        component: () => import('@/views/pms/product/index'),
        meta: {title: '商品回收站', icon: 'product-recycle'},
        hidden: true
      },
      {
        path: 'productComment',
        name: 'productComment',
        component: () => import('@/views/pms/product/index'),
        meta: {title: '商品评价', icon: 'product-comment'},
        hidden: true
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: {title: '商品分类', icon: 'product-cate'}
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: {title: '添加商品分类'},
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: {title: '修改商品分类'},
        hidden: true
      },
      {
        path: 'productAttr',
        name: 'productAttr',
        component: () => import('@/views/pms/productAttr/index'),
        meta: {title: '商品类型', icon: 'product-attr'}
      },
      {
        path: 'productAttrList',
        name: 'productAttrList',
        component: () => import('@/views/pms/productAttr/productAttrList'),
        meta: {title: '商品属性列表'},
        hidden: true
      },
      {
        path: 'addProductAttr',
        name: 'addProductAttr',
        component: () => import('@/views/pms/productAttr/addProductAttr'),
        meta: {title: '添加商品属性'},
        hidden: true
      },
      {
        path: 'updateProductAttr',
        name: 'updateProductAttr',
        component: () => import('@/views/pms/productAttr/updateProductAttr'),
        meta: {title: '修改商品属性'},
        hidden: true
      },
      {
        path: 'brand',
        name: 'brand',
        component: () => import('@/views/pms/brand/index'),
        meta: {title: '品牌管理', icon: 'product-brand'}
      },
      {
        path: 'addBrand',
        name: 'addBrand',
        component: () => import('@/views/pms/brand/add'),
        meta: {title: '添加品牌'},
        hidden: true
      },
      {
        path: 'updateBrand',
        name: 'updateBrand',
        component: () => import('@/views/pms/brand/update'),
        meta: {title: '编辑品牌'},
        hidden: true
      },*/
      {
        path: 'subject',
        name: 'subject',
        component: () => import('@/views/pms/subject/index'),
        meta: {title: '吉库子栏目', icon: 'product-brand'}
      },
      {
        path: 'subjectList',
        name: 'subjectList',
        component: () => import('@/views/pms/subject/index'),
        meta: {title: '吉库子栏目列表'},
        hidden: true
      },
      {
        path: 'addSubject',
        name: 'addSubject',
        component: () => import('@/views/pms/subject/add'),
        meta: {title: '添加吉库子栏目'},
        hidden: true
      },
      {
        path: 'updateSubject',
        name: 'updateSubject',
        component: () => import('@/views/pms/subject/update'),
        meta: {title: '修改吉库子栏目'},
        hidden: true
      },
      {
        path: 'series',
        name: 'series',
        component: () => import('@/views/pms/series/index'),
        meta: {title: '系列列表', icon: 'product-attr'}
      },
      {
        path: 'seriesList',
        name: 'seriesList',
        component: () => import('@/views/pms/series/index'),
        meta: {title: '系列列表'},
        hidden: true
      },
      {
        path: 'addSeries',
        name: 'addSeries',
        component: () => import('@/views/pms/series/add'),
        meta: {title: '添加系列'},
        hidden: true
      },
      {
        path: 'updateSeries',
        name: 'updateSeries',
        component: () => import('@/views/pms/series/update'),
        meta: {title: '修改系列'},
        hidden: true
      },
      {
        path: 'goods',
        name: 'goods',
        component: () => import('@/views/pms/goods/index'),
        meta: {title: '商品列表', icon: 'product-list'}
      },
      {
        path: 'goodsList',
        name: 'goodsList',
        component: () => import('@/views/pms/goods/index'),
        meta: {title: '商品列表'},
        hidden: true
      },
      {
        path: 'addGoods',
        name: 'addGoods',
        component: () => import('@/views/pms/goods/add'),
        meta: {title: '添加商品', icon: 'product-comment'}
      },
      {
        path: 'updateGoods',
        name: 'updateGoods',
        component: () => import('@/views/pms/goods/update'),
        meta: {title: '修改商品'},
        hidden: true
      },{
        path: 'calendar',
        name: 'calendar',
        component: () => import('@/views/pms/calendar/index'),
        meta: {title: '手机通胜',icon: 'product-list'}
      },
      {
        path: 'calendarList',
        name: 'calendarList',
        component: () => import('@/views/pms/calendar/index'),
        meta: {title: '日历列表'},
        hidden: true
      },
      {
        path: 'addCalendar',
        name: 'addCalendar',
        component: () => import('@/views/pms/calendar/add'),
        meta: {title: '添加日历'},
        hidden: true
      },
      {
        path: 'updateCalendar',
        name: 'updateCalendar',
        component: () => import('@/views/pms/calendar/update'),
        meta: {title: '修改日历'},
        hidden: true
      },
      {
        path: 'keyword',
        name: 'keyword',
        component: () => import('@/views/pms/keyword/index'),
        meta: {title: '搜索热门',icon: 'example'}
      }
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/ordernew',
    name: 'oms',
    meta: {title: '订单', icon: 'order'},
    children: [
      {
        path: 'ordernew',
        name: 'ordernew',
        component: () => import('@/views/oms/ordernew/index'),
        meta: {title: '订单列表', icon: 'product-list'}
      },
      {
        path: 'orderDetailNew',
        name: 'orderDetailNew',
        component: () => import('@/views/oms/ordernew/orderDetail'),
        meta: {title: '订单详情'},
        hidden:true
      },
      {
        path: 'auspiciousList',
        name: 'auspiciousList',
        component: () => import('@/views/oms/ordernew/auspiciousList'),
        meta: {title: '择吉订单', icon: 'product-list'}
      },
      {
        path: 'clacList',
        name: 'clacList',
        component: () => import('@/views/oms/ordernew/clacList'),
        meta: {title: '命理订单', icon: 'product-list'}
      },
      {
        path: 'editMeasure',
        name: 'editMeasure',
        component: () => import('@/views/oms/ordernew/editMeasure'),
        meta: {title: '择吉补充-抓用神'},
        hidden:true
      },
      {
        path: 'editMeasureMarry',
        name: 'editMeasureMarry',
        component: () => import('@/views/oms/ordernew/editMeasureMarry'),
        meta: {title: '择吉补充-结婚'},
        hidden:true
      },
      {
        path: 'editMeasureBury',
        name: 'editMeasureBury',
        component: () => import('@/views/oms/ordernew/editMeasureBury'),
        meta: {title: '择吉补充-安葬'},
        hidden:true
      },
      {
        path: 'editMeasureNewHome',
        name: 'editMeasureNewHome',
        component: () => import('@/views/oms/ordernew/editMeasureNewHome'),
        meta: {title: '择吉补充-入伙'},
        hidden:true
      },
      {
        path: 'editMeasureNameCompany',
        name: 'editMeasureNameCompany',
        component: () => import('@/views/oms/ordernew/editMeasureNameCompany'),
        meta: {title: '择吉补充-公司取名'},
        hidden:true
      },
      {
        path: 'editMeasureNamePerson',
        name: 'editMeasureNamePerson',
        component: () => import('@/views/oms/ordernew/editMeasureNamePerson'),
        meta: {title: '择吉补充-个人取名'},
        hidden:true
      },
      {
        path: 'deliverOrderListNew',
        name: 'deliverOrderListNew',
        component: () => import('@/views/oms/ordernew/deliverOrderList'),
        meta: {title: '发货列表'},
        hidden:true
      },
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/ordernew/setting'),
        meta: {title: '订单设置', icon: 'order-setting'}
      },
      {
        path: 'returnApply',
        name: 'returnApply',
        component: () => import('@/views/oms/ordernew/returnList'),
        meta: {title: '退货申请处理', icon: 'order-return'}
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/apply/reason'),
        meta: {title: '退货原因设置', icon: 'order-return-reason'},
        hidden:true
      },
      {
        path: 'returnApplyDetail',
        name: 'returnApplyDetail',
        component: () => import('@/views/oms/apply/applyDetail'),
        meta: {title: '退货原因详情'},
        hidden:true
      },
      {
        path: 'userCalendarList',
        name: 'userCalendarList',
        component: () => import('@/views/sys/user/usercalendar'),
        meta: {title: '通胜购买列表', icon: 'user'}
      },
      {
        path: 'calendarList1',
        name: 'calendarList1',
        component: () => import('@/views/sys/user/calendarlist'),
        meta: {title: '个人已购买列表', icon: 'user'},
        hidden: true
      },
      {
        path: 'commentList',
        name: 'commentList',
        component: () => import('@/views/oms/ordernew/commentList'),
        meta: {title: '订单评论', icon: 'user'}
      },
      {
        path: 'destingUserList',
        name: 'destingUserList',
        component: () => import('@/views/oms/ordernew/destingUserList'),
        meta: {title: '命理结果', icon: 'product-attr'}
      },
      {
        path: 'destinycalcresult',
        name: 'destinycalcresult',
        component: () => import('@/views/oms/ordernew/destinycalculateresult'),
        meta: {title: '测算结果'},
        hidden: true
      }
    ]
  },
  {
    path:'/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: {title: '营销', icon: 'sms'},
    children: [
      {
        path: 'couponnew',
        name: 'couponnew',
        component: () => import('@/views/sms/couponnew/index'),
        meta: {title: '优惠券列表', icon: 'sms-coupon'}
      },
      {
        path: 'addCouponNew',
        name: 'addCouponNew',
        component: () => import('@/views/sms/couponnew/add'),
        meta: {title: '添加优惠券', icon: 'sms-coupon'}
      },
      {
        path: 'activityList',
        name: 'activityList',
        component: () => import('@/views/sms/couponnew/activitylist'),
        meta: {title: '优惠活动列表', icon: 'sms-coupon'}
      },
      {
        path: 'addActivity',
        name: 'addActivity',
        component: () => import('@/views/sms/couponnew/addactivity'),
        meta: {title: '添加优惠活动'},
        hidden: true
      },
      {
        path: 'updateActivity',
        name: 'updateActivity',
        component: () => import('@/views/sms/couponnew/updateactivity'),
        meta: {title: '更新优惠活动'},
        hidden: true
      },
      {
        path: 'updateCouponNew',
        name: 'updateCouponNew',
        component: () => import('@/views/sms/couponnew/update'),
        meta: {title: '修改优惠券'},
        hidden:true
      },
      {
        path: 'couponHistory',
        name: 'couponHistory',
        component: () => import('@/views/sms/coupon/history'),
        meta: {title: '优惠券领取详情'},
        hidden:true
      },
      {
        path: 'pointList',
        name: 'pointList',
        component: () => import('@/views/sys/point/index'),
        meta: {title: '积分管理', icon: 'user'}
      },
      {
        path: 'moviePic',
        name: 'moviePic',
        component: () => import('@/views/sms/movie/moviePic'),
        meta: {title: '视频宣传册', icon: 'user'}
      },
      {
        path: 'movieList',
        name: 'movieList',
        component: () => import('@/views/sms/movie/index'),
        meta: {title: '视频列表', icon: 'product-list'}
      },
      {
        path: 'addMovie',
        name: 'addMovie',
        component: () => import('@/views/sms/movie/add'),
        meta: {title: '添加视频', icon: 'product-add'}
      },
      {
        path: 'updateMovie',
        name: 'updateMovie',
        component: () => import('@/views/sms/movie/update'),
        meta: {title: '修改视频'},
        hidden:true
      },
      {
        path: 'movieCommentList',
        name: 'movieCommentList',
        component: () => import('@/views/sms/movie/commentList'),
        meta: {title: '视频评论', icon: 'user'}
      },
      {
        path: 'groupList',
        name: 'groupList',
        component: () => import('@/views/sms/group/index'),
        meta: {title: '拼团设置', icon: 'product-list'}
      },
      {
        path: 'addGroup',
        name: 'addGroup',
        component: () => import('@/views/sms/group/add'),
        meta: {title: '添加拼团', icon: 'product-add'},
        hidden:true
      },
      {
        path: 'updateGroup',
        name: 'updateGroup',
        component: () => import('@/views/sms/group/update'),
        meta: {title: '修改拼团'},
        hidden:true
      },
      {
        path: 'groupBuyList',
        name: 'groupBuyList',
        component: () => import('@/views/sms/group/groupBuyList'),
        meta: {title: '拼团列表', icon: 'product-list'}
      }
    ]
  },
  {
    path:'/info',
    component: Layout,
    redirect: '/info/infoSubject',
    name: 'info',
    meta: {title: '宝典', icon: 'example'},
    children: [
      {
        path: 'infoSubject',
        name: 'infoSubject',
        component: () => import('@/views/info/subject/index'),
        meta: {title: '宝典栏目', icon: 'product-brand'}
      },
      {
        path: 'infoSubjectList',
        name: 'infoSubjectList',
        component: () => import('@/views/info/subject/index'),
		    meta: {title: '宝典栏目列表'},
        hidden: true
      },
      {
        path: 'addInfoSubject',
		    name: 'addInfoSubject',
		    component: () => import('@/views/info/subject/add'),
		    meta: {title: '添加宝典栏目'},
        hidden: true
      },
      {
        path: 'updateInfoSubject',
		    name: 'updateInfoSubject',
		    component: () => import('@/views/info/subject/update'),
		    meta: {title: '修改宝典栏目'},
        hidden: true
      },
      {
        path: 'infoSeries',
        name: 'infoSeries',
        component: () => import('@/views/info/series/index'),
        meta: {title: '子栏目', icon: 'product-attr'}
      },
      {
        path: 'infoSeriesList',
        name: 'infoSeriesList',
        component: () => import('@/views/info/series/index'),
        meta: {title: '子栏目列表'},
        hidden: true
      },
      {
        path: 'addInfoSeries',
        name: 'addInfoSeries',
        component: () => import('@/views/info/series/add'),
        meta: {title: '添加子栏目'},
        hidden: true
      },
      {
        path: 'updateInfoSeries',
        name: 'updateInfoSeries',
        component: () => import('@/views/info/series/update'),
        meta: {title: '修改子栏目'},
        hidden: true
      },
      {
        path: 'article',
        name: 'article',
        component: () => import('@/views/info/article/index'),
        meta: {title: '文章列表', icon: 'product-list'}
      },
      {
        path: 'articleList',
        name: 'articleList',
        component: () => import('@/views/info/article/index'),
        meta: {title: '文章列表'},
        hidden: true
      },
      {
        path: 'addArticle',
        name: 'addArticle',
        component: () => import('@/views/info/article/add'),
        meta: {title: '添加文章', icon: 'product-comment'}
      },
      {
        path: 'updateArticle',
        name: 'updateArticle',
        component: () => import('@/views/info/article/update'),
        meta: {title: '修改文章'},
        hidden: true
      },
    ]
  },

  {
    path:'/mem',
    component: Layout,
    redirect: '/mem/userList',
    name: 'mem',
    meta: {title: '会员', icon: 'sms'},
    children: [
      {
        path: 'userList',
        name: 'userList',
        component: () => import('@/views/sys/user/index'),
        meta: {title: '用户列表', icon: 'user'}
      },
      {
        path: 'policyList',
        name: 'policyList',
        component: () => import('@/views/sys/policy/index'),
        meta: {title: '会员说明', icon: 'tree'}
      },
      {
        path: 'mailList',
        name: 'mailList',
        component: () => import('@/views/sys/mail/index'),
        meta: {title: '站内信', icon: 'user'}
      }
    ]
  },
  {
    path:'/store',
    component: Layout,
    redirect: '/store/storeList',
    name: 'store',
    meta: {title: '门店', icon: 'sms'},
    children: [
      {
        path: 'storeList',
        name: 'storeList',
        component: () => import('@/views/sys/store/index'),
        meta: {title: '门店列表', icon: 'user'}
      },
      {
        path: 'updateStore',
        name: 'updateStore',
        component: () => import('@/views/sys/store/update'),
        meta: {title: '修改门店信息'},
        hidden: true
      },
      {
        path: 'addStore',
        name: 'addStore',
        component: () => import('@/views/sys/store/add'),
        meta: {title: '新增门店', icon: 'user'}
      }
    ]
  },
  {
    path:'/vs',
    component: Layout,
    redirect: '/vs/classifyList',
    name: 'vs',
    meta: {title: '虚拟祭祀', icon: 'sms'},
    children: [
      {
        path: 'classifyList',
        name: 'classifyList',
        component: () => import('@/views/vs/classify/index'),
        meta: {title: '商品类型', icon: 'user'}
      },
      {
        path: 'sceneList',
        name: 'sceneList',
        component: () => import('@/views/vs/scene/index'),
        meta: {title: '场景管理', icon: 'user'}
      },
      {
        path: 'addScene',
        name: 'addScene',
        component: () => import('@/views/vs/scene/add'),
        meta: {title: '新增场景'},
        hidden: true
      },
      {
        path: 'updateScene',
        name: 'updateScene',
        component: () => import('@/views/vs/scene/update'),
        meta: {title: '编辑场景'},
        hidden: true
      },
      {
        path: 'vsGoodsList',
        name: 'vsGoodsList',
        component: () => import('@/views/vs/goods/index'),
        meta: {title: '商品管理', icon: 'user'}
      },
      {
        path: 'addVsGoods',
        name: 'addVsGoods',
        component: () => import('@/views/vs/goods/add'),
        meta: {title: '新增商品'},
        hidden: true
      },
      {
        path: 'updateVsGoods',
        name: 'updateVsGoods',
        component: () => import('@/views/vs/goods/update'),
        meta: {title: '编辑商品'},
        hidden: true
      },
      {
        path: 'vsOrderList',
        name: 'vsOrderList',
        component: () => import('@/views/vs/order/index'),
        meta: {title: '订单管理', icon: 'user'}
      }
    ]
  },
  {
    path:'/sys',
    component: Layout,
    redirect: '/sys/Dic',
    name: 'sys',
    meta: {title: '系统', icon: 'order-setting'},
    children: [
      {
        path: 'dic',
        name: 'dic',
        component: () => import('@/views/sys/dic/index'),
        meta: {title: '系统编码', icon: 'product-cate'}
      },
      {
        path: 'dicList',
        name: 'dicList',
        component: () => import('@/views/sys/dic/index'),
        meta: {title: '系统编码表列表'},
        hidden: true
      },
      {
        path: 'addDic',
        name: 'addDic',
        component: () => import('@/views/sys/dic/add'),
        meta: {title: '添加系统编码表'},
        hidden: true
      },
      {
        path: 'updateDic',
        name: 'updateDic',
        component: () => import('@/views/sys/dic/update'),
        meta: {title: '修改系统编码表'},
        hidden: true
      },
      {
        path: 'about',
        name: 'about',
        component: () => import('@/views/sys/about/about'),
        meta: {title: '公司介绍', icon: 'sms-subject'}
      },
      {
        path: 'protocol',
        name: 'protocol',
        component: () => import('@/views/sys/about/protocol'),
        meta: {title: '用户协议', icon: 'form'}
      },
      {
        path: 'policy',
        name: 'policy',
        component: () => import('@/views/sys/about/policy'),
        meta: {title: '隐私政策', icon: 'eye'}
      },
      {
        path: 'addPolicy',
        name: 'addPolicy',
        component: () => import('@/views/sys/policy/add'),
        meta: {title: '添加会员配置'},
        hidden: true
      },
      {
        path: 'updatePolicy',
        name: 'updatePolicy',
        component: () => import('@/views/sys/policy/update'),
        meta: {title: '修改会员配置'},
        hidden: true
      },
      {
        path: 'treeTableDemo',
        name: 'treeTableDemo',
        component: () => import('@/views/sys/test/test'),
        meta: {title: '测试', icon: 'form'}
      },
      {
        path: 'updateReturn',
        name: 'updateReturn',
        component: () => import('@/views/sys/about/return'),
        meta: {title: '退货配置', icon: 'form'}
      },
      {
        path: 'updateRefund',
        name: 'updateRefund',
        component: () => import('@/views/sys/about/refund'),
        meta: {title: '退款配置', icon: 'form'}
      },
      {
        path: 'appSwitchList',
        name: 'appSwitchList',
        component: () => import('@/views/sys/appswitch/index'),
        meta: {title: '配置列表', icon: 'user'}
      }

    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js